import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#0F172A] border-t border-slate-800 pt-16 pb-8 lg:px-8 px-4 relative text-white">

      {/* Top CTA Banner */}
      <div className="text-left max-w-7xl mx-auto mb-16 relative overflow-hidden rounded-[3rem] shadow-[0_0_50px_rgba(0,0,0,0.5)] border border-slate-700/50">
        {/* CTA Background Image */}
        <img
          src="https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&q=80&w=1200"
          alt="Team Strategy"
          width={1200}
          height={800}
          loading="lazy"
          decoding="async"
          className="absolute inset-0 w-full h-full object-cover opacity-30 hover:scale-105 transition-transform duration-1000"
        />
        {/* CTA Colorful Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#0F172A] via-[#0F172A]/80 to-[#2563EB]/20" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#F43F5E]/10 to-transparent" />

        <div className="relative z-10 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8 p-8 md:p-20">
          <div className="max-w-2xl text-left">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight drop-shadow-2xl text-white">Master Your Personal Finances And Build Lasting Wealth</h2>
            <p className="text-[#2563EB] font-semibold text-lg tracking-wide">Join 40,000+ active students globally.</p>
          </div>
          <div className="flex flex-col sm:flex-row gap-5 shrink-0 w-full lg:w-auto">
            <Link to="/signup" className="w-full sm:w-auto relative group overflow-hidden bg-[#2563EB] text-white px-8 py-4 rounded-xl font-semibold hover:bg-blue-500 transition-all duration-300 shadow-[0_0_40px_-10px_rgba(37,99,235,0.7)] text-lg flex gap-2 items-center justify-center hover:-translate-y-1">
              Join Now
            </Link>
            <a href="https://personalfinancecare.net/" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto bg-slate-800/40 backdrop-blur-md border border-slate-700 text-white px-8 py-4 rounded-xl font-semibold hover:bg-slate-800 hover:border-[#F43F5E]/50 hover:text-white transition-all duration-300 shadow-lg hover:-translate-y-1 inline-flex items-center justify-center text-lg gap-3 group">Contact Us</a>
          </div>
        </div>
      </div>

      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto flex justify-between flex-wrap gap-12 border-b border-slate-800 pb-12 mb-8 text-left">

        {/* Brand & Description Column (Spans 2 columns) */}
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-6 group">
            <Link to="/" className="flex items-center gap-2 group">
              <img src="/personalfinanceacademy-logo.svg?v=2" alt="Logo" width={460} height={67} loading="lazy" decoding="async" className="w-[160px] sm:w-[200px] md:w-[250px]" />
            </Link>


          </div>

          <p className="text-slate-400 text-sm max-w-sm leading-relaxed">Empowering individuals with modern personal finance skills. Learn budgeting, investing, and wealth-building strategies anywhere, anytime.</p>




        </div>

        {/* Platform Links */}
        <div>
          <h4 className="font-bold mb-6 text-white tracking-wide">Platform</h4>
          <ul className="space-y-4 text-slate-400 text-sm">
            <li><Link to="/" className="hover:text-[#2563EB] transition-colors">Home</Link></li>
            <li><Link to="/library" className="hover:text-[#2563EB] transition-colors">Library</Link></li>
            <li><Link to="/terms-and-conditions" className="hover:text-[#2563EB] transition-colors">Terms and conditions</Link></li>
            <li><Link to="/privacy-policy" className="hover:text-[#2563EB] transition-colors">Privacy policy</Link></li>
          </ul>
        </div>

        {/* Company Details */}
        <div>
          <h4 className="font-bold mb-6 text-white tracking-wide">Company Details</h4>
          <ul className="space-y-4 text-slate-400 text-sm">
            <li>Company Name: OLBMI ltd.</li>
            <li className="leading-relaxed">Company Address: 10 Mnasiadou, 2nd Floor, 1065 Nicosia</li>
            <li className="hover:text-[#F43F5E] cursor-pointer transition-colors">Email: <a href="mailto:support@personalfinanceacademy.net" className="text-[#2563EB] font-bold hover:underline">support@personalfinanceacademy.net</a></li>
          </ul>
        </div>
      </div>

      {/* Copyright */}
      <div className="text-center text-slate-500 text-sm font-medium">
        © {new Date().getFullYear()} personalfinanceacademy. All rights reserved.
      </div>
    </footer>
  );
}
